import { Skeleton, Stack } from '@/theme/index';
import { StyledBox } from '../components';

export const VehicleSmartInsightHistoryBasedValueSkeleton = () => {
  return (
    <StyledBox>
      <Stack>
        <Skeleton
          sx={{ fontSize: '1.5rem', width: '30%' }}
          className="dark-mode"
        />
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          alignItems={{ xs: 'flex-start', sm: 'flex-end' }}
        >
          <Skeleton
            sx={{ fontSize: '1.5rem', width: '100%' }}
            className="dark-mode"
          />
        </Stack>
      </Stack>
    </StyledBox>
  );
};
